var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ru:base-video"},[_c('video',{ref:"video",staticClass:"focus:outline-none",attrs:{"autoplay":"","controls":""}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }